module.exports = __webpack_public_path__ + "img/coin-XRP.80a09b13.svg";